import { reportApi } from '../http/httpClient'
import { StatusCommission, TypeCommission } from '@/app/utils/statusCommission'

export interface ReportCommission {
  user: string
  cpf: string
  type: TypeCommission
  transaction_contract: string
  transaction_value: number
  value: number
  status: StatusCommission
  createdAt: string

  team?: string
  manager?: string
  supervisor?: string
  leader?: string
}

export interface ReportCommissionResponse {
  commissions: ReportCommission[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportCommissionParams {
  sellerIds?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportCommission(
  params?: ReportCommissionParams | undefined,
) {
  const { data } = await reportApi.get<ReportCommissionResponse>(
    '/report/commissions',
    {
      params,
    },
  )

  return data
}
